import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Button, Table } from '@themesberg/react-bootstrap';
import { CustomToast, Loader, MyPagination } from '../../components/common';
import { Link } from 'react-router-dom';
import { Routes } from '../../config/routes';
import { paginateList } from '../../utils/reusableFunctions';
import { useGetKeywordsQuery } from '../../features/keywords/keywords.api';

const KeywordsTable = () => {
  const { keywords, isSuccess } = useGetKeywordsQuery(undefined, {
    selectFromResult: ({ data, isSuccess }) => ({
      keywords: data ? data.results : [],
      isSuccess,
    }),
  });
  const keywordsPerPage = 10;

  const [currentPage, setCurrentPage] = useState(1);
  let keywordList = paginateList(keywords, currentPage, keywordsPerPage);

  const handlePageClicked = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(keywords.length / keywordsPerPage);

  const Header = () => (
    <div className='table-settings mb-4 mt-4'>
      <Row className='justify-content-between align-items-center'>
        <Col className='ps-md-0 text-end'>
          <Button
            variant='primary'
            size='sm'
            className='me-2'
            as={Link}
            to={Routes.NewKeyword.path}
          >
            <FontAwesomeIcon
              icon={faPlus}
              className='me-2'
            />
            New Keyword
          </Button>
        </Col>
      </Row>
    </div>
  );

  const TableRow = (props) => {
    const { id, text } = props;

    return (
      <>
        <tr>
          <td>
            <span className='fw-normal'>{text}</span>
          </td>
          <td>
            <Button
              variant='primary'
              type='submit'
              as={Link}
              to={`${Routes.KeywordEdit.path}/${id}`}
            >
              <FontAwesomeIcon
                icon={faEdit}
                className='me-2'
              />{' '}
              Edit
            </Button>
          </td>
        </tr>
      </>
    );
  };

  return (
    <Loader loaded={isSuccess}>
      <CustomToast />
      <Header />
      <MyPagination
        totPages={totalPages}
        currentPage={currentPage}
        pageClicked={(page) => {
          handlePageClicked(page);
        }}
      >
        <Card
          border='light'
          className='table-wrapper table-responsive shadow-sm'
        >
          <Card.Body className='pt-0'>
            <Table
              hover
              className='user-table align-items-center text-black'
            >
              <thead>
                <tr>
                  <th className='border-bottom'>Text</th>
                  <th className='border-bottom'>Action</th>
                </tr>
              </thead>
              <tbody>
                {keywordList.map((r) => (
                  <TableRow
                    key={`keyword-${r.id}`}
                    {...r}
                  />
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </MyPagination>
    </Loader>
  );
};

export default KeywordsTable;
